<template>
  <div class="carousel">
    <swiper :options="swiperOptions">
      <swiper-slide v-for="item in curMeal.KsContainBanJiList" :key="item.BzNum">
        <div class="box">
          <h4>{{ item.BzCName }}</h4>
          <p>有效期至：{{ item.Validity }}</p>
          <div class="labels">
            <label v-if="item.JiaoCaiFlag === 1">送教材</label>
            <label v-if="item.JiaoFuFlag === 1">送教辅</label>
            <label v-if="item.TikuFlag === 1">送题库</label>
          </div>
          <div class="bottom">
            <div class="price">
              <template v-if="isShowPrice">
                <span>¥</span>
                <label>{{ item.ActivityFlag === 1 ? item.ActivityPrice : item.GoodPrice }}</label>
                <del v-if="item.ActivityFlag === 1">¥{{ item.GoodPrice }}</del>
              </template>
            </div>
            <div class="buttom" @click="changeClassObj(item)">{{ isShowPrice ? "购买" : "咨询客服" }}</div>
            <img src="https://img2.233.com/wx/union/pure/pc/hdj_bg.png" class="flag" v-if="item.ActivityFlag === 1" />
          </div>
          <div class="again" v-if="item.RelearnFlag === 1 && ShowRelearn === 0">重学服务</div>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev" v-if="curMeal.KsContainBanJiList.length > 4"></div>
      <div class="swiper-button-next" slot="button-next" v-if="curMeal.KsContainBanJiList.length > 4"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    ShowRelearn: {
      type: Number,
      default: 0
    },
    curMeal: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      swiperOptions: {
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 20
      }
    };
  },
  computed: {
    // 是否显示价格
    isShowPrice() {
      return this.$store.getters["common/isShowPrice"];
    }
  },
  methods: {
    changeClassObj(item) {
      if(!this.isShowPrice) {
        window.core233.project.unionKefuDialog()
        return
      }
      if (item.BzContainMyClassList.length === 1) {
        window.open("/shopping/?myclassid=" + item.BzContainMyClassList[0].MyClassId);
        return;
      } else {
        this.$emit("changeClassObj", item);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel {
  margin-bottom: 60px;
  .box {
    height: 222px;
    background: white;
    box-shadow: 1px 15px 18px 1px rgba(0, 0, 0, 0.02);
    position: relative;
    h4 {
      color: #343434;
      font-size: 17px;
      font-weight: 400;
      padding: 32px 15px 0;
    }
    p {
      color: #343434;
      font-size: 13px;
      font-weight: 300;
      padding: 5px 15px 22px;
    }
    .labels {
      padding: 0 15px;
      label {
        background: #fdf5f5;
        height: 21px;
        line-height: 21px;
        display: inline-block;
        padding: 0 7px;
        color: #dd7a7a;
        font-size: 12px;
        font-weight: 400;
        margin-right: 7px;
      }
    }
    .bottom {
      height: 60px;
      background: #f9f9f9;
      padding: 0 15px;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        span {
          font-size: 16px;
          color: #df3030;
          font-weight: 400;
        }
        label {
          font-size: 22px;
          color: #df3030;
          font-weight: 400;
          margin: 0 8px 0 4px;
        }
        del {
          font-size: 16px;
          color: #9a9a9a;
          font-weight: 400;
        }
      }
      .buttom {
        min-width: 59px;
        padding: 0 12px;
        height: 30px;
        display: inline-block;
        line-height: 30px;
        border-radius: 15px;
        text-align: center;
        border: 1px solid #df3030;
        color: #df3030;
        font-size: 15px;
        font-weight: 400;
        margin-right: 11px;
        cursor: pointer;
        transition: 0.2s;
        &:hover {
          transform: translateY(-5px);
        }
      }
      .flag {
        position: absolute;
        width: 70px;
        height: 40px;
        top: -16px;
        left: 4px;
      }
    }
    .again {
      position: absolute;
      width: 100px;
      height: 31px;
      top: 0;
      left: 0;
      background: url(https://img2.233.com/wx/union/pure/pc/cxfw_bg.png) no-repeat center center;
      font-size: 12px;
      color: white;
      line-height: 22px;
      text-align: left;
      padding-left: 10px;
      box-sizing: border-box;
    }
  }
  .swiper-button-prev {
    background: url(https://img2.233.com/wx/union/pure/pc/btn_left.png) no-repeat;
    background-size: 100% 100%;
    width: 44px;
    height: 88px;
    margin-top: -44px;
    left: 0;
    &::after {
      content: "";
    }
    &:hover {
      background: url(https://img2.233.com/wx/union/pure/pc/btn_left_hover.png) no-repeat;
    }
  }
  .swiper-button-next {
    background: url(https://img2.233.com/wx/union/pure/pc/btn_right.png) no-repeat;
    background-size: 100% 100%;
    width: 44px;
    height: 88px;
    margin-top: -44px;
    right: 0;
    &::after {
      content: "";
    }
    &:hover {
      background: url(https://img2.233.com/wx/union/pure/pc/btn_right_hover.png) no-repeat;
    }
  }
}
</style>
